import type { ScheduledMeeting } from '../contexts';
import type { MeetingTypeVariant } from './meetingAccessPolicy';

export type DerivedMeetingType = MeetingTypeVariant;

/**
 * Derive meeting type from API response fields:
 * - members_only:true + domains present -> Standard
 * - members_only:true + no domains -> Private
 * - members_only:false -> Open
 */
export const deriveMeetingType = (meeting: ScheduledMeeting): DerivedMeetingType => {
  const options = meeting.options as Record<string, unknown> | undefined;
  const membersOnly = options?.members_only;

  if (membersOnly === false) {
    return 'open';
  }

  if (Array.isArray(meeting.domains) && meeting.domains.length > 0) {
    return 'standard';
  }

  return 'private';
};
